<template>
  <article class="mini-kasko-offers__card">
    <div class="mini-kasko-offers__card-main">

      <!-- Компанія -->
      <div class="mini-kasko-offers__company">
        <div class="mini-kasko-offers__company-logo" :style="{ '--logo-accent': offer.logoAccent }">
          <InsuranceCompanyLogo :logo="offer.logoUrl" :alternativeText="offer.name"></InsuranceCompanyLogo>
        </div>
        <p class="mini-kasko-offers__company-name">{{ offer.companyName }}</p>

        <span v-if="offer.programName" class="mini-kasko-offers__program-badge">
          {{ offer.programName }}
        </span>

        <div v-if="offer.rating !== null" class="mini-kasko-offers__rating" :aria-label="`Рейтинг ${offer.rating} з 5`">
          <span
            v-for="star in 5"
            :key="`${offer.id}-star-${star}`"
            class="mini-kasko-offers__star"
            :class="{ 'mini-kasko-offers__star--active': star <= offer.rating }"
          >★</span>
        </div>

<!--        <a-->
<!--          v-if="offer.companyLink"-->
<!--          :href="offer.companyLink"-->
<!--          target="_blank"-->
<!--          rel="noopener noreferrer"-->
<!--          class="mini-kasko-offers__link"-->
<!--        >-->
<!--          <span class="mini-kasko-offers__link-icon">-->
<!--            <svg viewBox="0 0 24 24" aria-hidden="true">-->
<!--              <path d="M12 21s6-5.33 6-11a6 6 0 1 0-12 0c0 5.67 6 11 6 11Z" fill="#0A77FF"/>-->
<!--              <circle cx="12" cy="10" r="2.5" fill="#fff"/>-->
<!--            </svg>-->
<!--          </span>-->
<!--          відділення-->
<!--        </a>-->
      </div>

      <!-- Деталі + покриття -->
      <div class="mini-kasko-offers__details">
        <div class="mini-kasko-offers__details-grid">
          <MiniKaskoCoverageSelect
            v-model="selectedOfferIdx"
            :offers="offer.offers"
            :select-id="`coverage-${offer.id}`"
          />
          <div v-if="offer.title" class="mini-kasko-offers__detail mini-kasko-offers__detail--product">
            <div class="mini-kasko-offers__detail-value mini-kasko-offers__detail-value--product">
              {{ offer.title }}
            </div>
            <div class="mini-kasko-offers__detail-label">Продукт</div>
          </div>
        </div>

        <button
          type="button"
          class="mini-kasko-offers__secondary-action"
          :aria-expanded="isExpanded"
          @click="isExpanded = !isExpanded"
          v-if="generalInfoItems.length"
        >
          Детальніше про поліс
          <span
            class="mini-kasko-offers__secondary-action-icon"
            :class="{ 'mini-kasko-offers__secondary-action-icon--expanded': isExpanded }"
          >
            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path d="m4 6 4 4 4-4" fill="none" stroke="#0A77FF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </button>
      </div>

      <!-- Ціна -->
      <div class="mini-kasko-offers__price">
        <div class="mini-kasko-offers__price-value">
          {{ currentOffer.price }}
          <span class="mini-kasko-offers__price-currency">₴</span>
        </div>
        <div
          v-if="showEarnings && currentOffer.earnings !== null && currentOffer.earnings !== undefined"
          class="mini-kasko-offers__earnings"
        >
          <div>Заробіток: {{ currentOffer.earnings }} ₴</div>
          <div
            v-if="currentOffer.earningsPercent !== null && currentOffer.earningsPercent !== undefined"
            class="mini-kasko-offers__earnings-percent"
          >
            ({{ currentOffer.earningsPercent }}%)
          </div>
        </div>
        <button
          type="button"
          class="mini-kasko-offers__primary-action"
          @click="selectOffer"
        >
          Оформити
        </button>
      </div>
    </div>

    <!-- Розгорнута інформація -->
    <section v-if="isExpanded" class="mini-kasko-offers__expanded">
      <div class="mini-kasko-offers__tabs">
        <div class="mini-kasko-offers__tab mini-kasko-offers__tab--active">
          Загальна інформація
        </div>
      </div>
      <div class="mini-kasko-offers__expanded-content">
        <a
          v-for="item in generalInfoItems"
          :key="item.title"
          :href="item.href"
          target="_blank"
          rel="noopener noreferrer"
          class="mini-kasko-offers__info-row"
        >
          <span>{{ item.title }}</span>
          <span class="mini-kasko-offers__info-row-arrow">›</span>
        </a>
      </div>
      <ProductDescription :description="offer.company.description" />
    </section>
  </article>
</template>

<script>
import MiniKaskoCoverageSelect from './MiniKaskoCoverageSelect.vue';
import { UkaskoGrayIcon } from '@/shared/ui/icons';
import { ProductDescription } from '@/shared/ui/insurance';
import { InsuranceCompanyLogo } from '@/shared/ui/insurance-company-logo';

export default {
  components: { MiniKaskoCoverageSelect, UkaskoGrayIcon, InsuranceCompanyLogo, ProductDescription },
  props: {
    offer: {
      type: Object,
      required: true,
    },
    showEarnings: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: false,
      selectedOfferIdx: 0,
    };
  },
  computed: {
    currentOffer() {
      return this.offer.offers[this.selectedOfferIdx] || this.offer.offers[0] || {};
    },
    generalInfoItems() {
      return [
        { title: 'Інформація про страховий продукт', href: this.offer.company?.docProduct },
        { title: 'Інформація про страхову компанію', href: this.offer.company?.docCompany },
        { title: 'Інформація про страхового посередника', href: this.offer.company?.docAgent },
        { title: 'Інформація про загальні умови страхового продукту', href: this.offer.company?.docZusp },
      ].filter((item) => item.href);
    },
  },
  methods: {
    selectOffer() {
      this.$emit('select-offer', {
        offerId: this.currentOffer.offerId,
        price: this.currentOffer.price,
        coverage: this.currentOffer.coverage,
        companyName: this.offer.companyName,
        earnings: this.currentOffer.earnings,
        earningsPercent: this.currentOffer.earningsPercent,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mini-kasko-offers {
  &__card {
    background: #ffffff;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 2px rgba(15, 23, 42, 0.04);
    transition: box-shadow 0.2s ease, border-color 0.2s ease;

    &:hover {
      border-color: #b8c4d3;
      box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08), 0 2px 6px rgba(15, 23, 42, 0.06);
    }
  }

  &__card-main {
    display: grid;
    grid-template-columns: 200px minmax(0, 1fr) 200px;
  }

  &__company,
  &__details,
  &__price {
    min-width: 0;
  }

  &__company {
    padding: 28px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #cbd5e1;
  }

  &__company-logo {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;

    ::v-deep .logo {
      max-width: 100px;
      max-height: 100px;
      margin-right: 0;
    }
  }

  &__company-logo-image {
    display: block;
    max-width: 136px;
    max-height: 40px;
    object-fit: contain;
  }

  &__company-logo-name {
    font-size: 30px;
    line-height: 1;
    font-weight: 700;
    letter-spacing: -0.04em;
    color: #2f3b7a;
  }

  &__company-logo-subtitle {
    font-size: 10px;
    line-height: 1.2;
    letter-spacing: 0.08em;
    font-weight: 600;
    color: #4b5563;
  }

  &__company-name {
    margin: 0 0 14px;
    font-size: 14px;
    line-height: 1.43;
    text-align: center;
  }

  &__program-badge {
    display: inline-block;
    margin-bottom: 10px;
    padding: 3px 10px;
    border-radius: 999px;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    color: #1d4ed8;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.4;
    text-align: center;
  }

  &__rating {
    display: flex;
    gap: 2px;
    margin-bottom: 12px;
  }

  &__star {
    color: #e5e7eb;
    font-size: 15px;
    &--active { color: #f59e0b; }
  }

  &__link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 0;
    background: transparent;
    color: #0a77ff;
    font-size: 14px;
    line-height: 1.43;
    cursor: pointer;
    margin-bottom: 14px;
    padding: 0;
  }

  &__link-icon {
    display: inline-flex;
    width: 16px;
    height: 16px;
    svg { width: 100%; height: 100%; }
  }

  &__details {
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-right: 1px solid #cbd5e1;
  }

  &__details-grid {
    display: grid;
    /*grid-template-columns: repeat(2, minmax(0, 1fr));*/
    grid-template-columns: minmax(0, 1fr) minmax(0, 3fr);
    gap: 16px;
    margin-bottom: 16px;
  }

  &__detail {
    display: flex;
    flex-direction: column;
    gap: 6px;

    &--product {
      justify-content: center;
    }
  }

  &__detail-value {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;

    &--product {
      font-size: 16px;
      line-height: 1.5;
      font-weight: 600;
      color: #0f172a;
    }
  }

  &__detail-label {
    color: #717680;
    font-size: 14px;
    line-height: 1.43;
  }

  &__secondary-action {
    width: 100%;
    min-height: 44px;
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    background: #ffffff;
    color: #0a77ff;
    font-size: 16px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease;

    &:hover { border-color: #93c5fd; background: #f8fbff; }
  }

  &__secondary-action-icon {
    display: inline-flex;
    width: 16px;
    height: 16px;
    transition: transform 0.2s ease;
    svg { width: 100%; height: 100%; display: block; }
    &--expanded { transform: rotate(180deg); }
  }

  &__price {
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 33px;
  }

  &__price-value {
    display: inline-flex;
    align-items: flex-start;
    justify-content: center;
    font-size: 30px;
    line-height: 36px;
    font-weight: 600;
    text-align: center;
    letter-spacing: -0.04em;
  }

  &__price-currency {
    font-size: 16px;
    font-weight: 400;
    line-height: 18px;
    margin-left: 6px;
    margin-top: 9px;
  }

  &__earnings {
    font-size: 14px;
    line-height: 1.43;
    color: #16a34a;
    text-align: center;
    background: #f0fdf4;
    border-radius: 6px;
    padding: 8px 10px;
    width: 158px;
  }

  &__earnings-percent {
    color: #71717a;
    font-size: 12px;
    line-height: 16px;
  }

  &__primary-action {
    text-align: center;
    width: 158px;
    height: 50px;
    border: 0;
    border-radius: 6px;
    background: #fb923c;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover { background: #f97316; }
    &:active { background: #ea580c; }
  }

  &__expanded {
    border-top: 1px solid #cbd5e1;
    background: #ffffff;
    padding: 20px;
  }

  &__tabs {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-bottom: 20px;
  }

  &__tab {
    position: relative;
    border: 0;
    background: transparent;
    color: #18181b;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    padding: 0 0 8px;
    cursor: pointer;

    &--active::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 2px;
      border-radius: 999px;
      background: #fb923c;
    }
  }

  &__expanded-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__info-row {
    min-height: 40px;
    padding: 10px 14px;
    border: 0;
    border-radius: 8px;
    background: #f8fafc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    color: #3f3f46;
    cursor: pointer;
    text-decoration: none;
  }

  &__info-row-arrow {
    color: #0a77ff;
    font-size: 20px;
    line-height: 1;
  }

  @media (max-width: 1050px) {
    &__card-main { grid-template-columns: 1fr; }

    &__company,
    &__details { border-right: 0; border-bottom: 1px solid #cbd5e1; }

    &__company { align-items: flex-start; }
    &__company-name { text-align: left; }

    &__tabs { justify-content: flex-start; gap: 24px; }
  }

  @media (max-width: 640px) {
    &__details,
    &__company,
    &__price { padding: 16px; }

    &__details-grid {
      grid-template-columns: 1fr;
    }

    &__price-value { font-size: 36px; }

    &__secondary-action,
    &__primary-action { font-size: 16px; }

    &__expanded { padding: 16px; }

    &__tabs { gap: 16px; flex-wrap: wrap; }
  }
}
</style>
